var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradeQuestionUnansweredIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.126 3.14219L17.9588 15.007C18.4377 15.843 17.819 16.875 16.833 16.875H3.16739C2.18145 16.875 1.5627 15.843 2.04161 15.007L8.87442 3.14219C9.36661 2.28594 10.6338 2.28594 11.126 3.14219Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 15.4831C10.4972 15.4831 10.9001 15.0802 10.9001 14.5831C10.9001 14.086 10.4972 13.6831 10.0001 13.6831C9.50304 13.6831 9.1001 14.086 9.1001 14.5831C9.1001 15.0802 9.50304 15.4831 10.0001 15.4831Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 6.6665V12.0832",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradeQuestionUnansweredIcon);
export default __webpack_public_path__ + "static/media/grade-question-unanswered-icon.994b83adaaa090576007e17187245a6f.svg";
export { ForwardRef as ReactComponent };